import { Spacer, Card } from '@components/1-atoms';
import { AppTemplate } from '@components/4-templates';
import { Button, IconButton, Dropdown, Info, Input } from '@components/2-molecules';
import React, { FC } from 'react';
import { STATE, initialValue } from '@lib/constants';
import { useProductsServices } from '@lib/hooks/useProductService';
import { withForwardedNavigationParams } from 'react-navigation-props-mapper';
import * as utils from '@lib/utils';
import { useAccountOfType_direct_cost, useAccountOfType_sales, useAccountOfType_stock, useInvenrotyAccount, useSaleAccount } from '@lib/hooks/useAccount';
import { useTax } from '@lib/hooks/useTax';

import { Modal } from '@components/1-atoms';
import Menu from '@assets/icons/menu';
import Sandwich from '@assets/icons/sandwich';
import { DashboardMenu } from '@components/3-organisms';
import {
  PageHeader
} from '@components/2-molecules';

import { ForwardedPageProps } from '@lib/constants';


const InventoryProductCreate: FC<ForwardedPageProps> = ({ navigation, data = {}, onDone, ...props }) => {

  const [stockAccounts,] = useAccountOfType_stock({ state: STATE.READY });
  const [directCostAccounts,] = useAccountOfType_direct_cost({ state: STATE.READY });
  const [saleAccounts,] = useAccountOfType_sales({ state: STATE.READY });
  
  const [taxes,] = useTax({ state: STATE.READY });

  const [productOrService, setProductOrService] = useProductsServices({ operation: 'POST', data: data, state: STATE.CANCEL });

  const _onDone = (data: any) => navigation.navigate('ProductsServices', {});
  onDone = onDone || _onDone;
  utils.onStateChange(productOrService , STATE.DONE, onDone);
  
  const extraData = { isInventory: true }; // Need a checkbox for this!
  const createAccount = (): void => { setProductOrService({ ...productOrService, data: { ...productOrService.data, ...extraData }, state: STATE.READY, message: 'Creating account ...' }) };

  const updateData = (data: any): void => setProductOrService((productOrService: any) => ({ ...productOrService, data: { ...productOrService.data, ...data } }));

  return (
    <AppTemplate hooks={[stockAccounts, directCostAccounts, saleAccounts, productOrService]}>
      
      <PageHeader 
        title={"CREATE A PRODUCT OR SERVICE"}
        left={<IconButton  icon={<Sandwich />} onPress={navigation?.toggleDrawer} />}
      />
      <Spacer h={1} />

      <Card title='GENERAL'>
        <Spacer h={1} />
        <Input
          required
          label={"Name"}
          defaultValue={productOrService?.data?.name}
          onChange={(value: any) => { updateData({ name: value }) }}
        />
        <Spacer h={1} />
      </Card>
      <Spacer h={2} />


      <Card title={"COST OF PRODUCT / GOOD SOLD"}>
        <Info>Use this to track expenses that are directly attributable to the product or service you are selling. If there is a type of expense that cannot be attributable to sales, then you should create an Operating Expense category instead.</Info>
        <Spacer h={2} />
        <Dropdown
          required
          label={"Cost of goods sold (GOGS)"}
          defaultValue={productOrService?.data?.cogsAccount}
          data={directCostAccounts?.data}
          onChange={(value: any) => { updateData({ cogsAccount: value, cogsAccountId: value?.id, }) }}
        />
      </Card>
      <Spacer h={2} />

      <Card title={"INVENTORY / PURCHASE"}>
        <Info>Use this to track the value of physical items you have as inventory that are waiting to be sold.</Info>
        <Spacer h={2} />
        <Dropdown
          required
          label={"Inventory account"}
          placeholder={"Track the quantity and value on hand."}
          defaultValue={productOrService?.data?.purchaseAccount}
          data={stockAccounts?.data}
          onChange={(value: any) => { updateData({ purchaseAccount: value, purchaseAccountId: value?.id, }) }}
        />
        <Spacer h={2} />
        <Dropdown
          required
          label={"Tax"}
          defaultValue={productOrService?.data?.purchaseTax}
          data={taxes?.data}
          onChange={(value: any) => { updateData({ purchaseTax: value, purchaseTaxId: value?.id, }) }}
        />
      </Card>
      <Spacer h={2} />

      <Card title={"SELL"}>
        <Info>Use this to track all your sales to customers, whether your customer has made a payment or not, as long as you issued them an invoice.</Info>
        <Spacer h={2} />
        <Input
          required
          label={"Selling price"}
          defaultValue={productOrService?.data?.sellingPrice}
          onChange={(value: any) => { updateData({ sellingPrice: value }) }}
        />
        <Spacer h={2} />
        <Dropdown
          required
          label={"Sale account"}
          defaultValue={productOrService?.data?.saleAccount}
          data={saleAccounts?.data}
          onChange={(value: any) => { updateData({ saleAccount: value, saleAccountId: value?.id, }) }}
        />
        <Spacer h={2} />
        <Dropdown
          required
          label={"Tax"}
          data={taxes?.data}
          defaultValue={productOrService?.data?.saleTax}
          onChange={(value: any) => { updateData({ saleTax: value, saleTaxId: value?.id, }) }}
        />
      </Card>
      <Spacer h={2} />

      <Button onPress={createAccount}>CREATE</Button>
      
      <Spacer h={2} />
    </AppTemplate>
  );
};


export default withForwardedNavigationParams<ForwardedPageProps>()(InventoryProductCreate);